import { render, staticRenderFns } from "./ChangeStoreSideMenuContents.vue?vue&type=template&id=c852b6e2"
import script from "./ChangeStoreSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeStoreSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChangeStoreSideMenuContents.vue?vue&type=style&index=0&id=c852b6e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports